import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import { LandingPage } from './pages/LandingPage';
import { initMetaPixel } from './utils/metaPixel';
// Initialize Meta Pixel on app load
initMetaPixel();
const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
root.render(<React.StrictMode data-id="element-565">
    <LandingPage data-id="element-566" />
  </React.StrictMode>);